import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useEffect } from 'react';
import { usePrevious } from './use-previous';
export var useAutoResizable = function useAutoResizable(_ref) {
  var textArea = _ref.textArea,
    counterRef = _ref.counterRef,
    autoHeight = _ref.autoHeight,
    maxRows = _ref.maxRows,
    initRows = _ref.initRows,
    value = _ref.value;
  var _React$useState = React.useState(initRows),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    rows = _React$useState2[0],
    setRows = _React$useState2[1];
  var prevRows = usePrevious(rows);
  var calculateRowsCount = React.useCallback(function () {
    if (!textArea.current || !autoHeight || !counterRef.current) {
      return;
    }
    var computedStyle = getComputedStyle(textArea.current);
    var value = textArea.current.value;
    counterRef.current.style.width = computedStyle.width;
    counterRef.current.value = value;
    if (counterRef.current.value.slice(-1) === '\n') {
      counterRef.current.value += ' ';
    }
    var innerHeight = counterRef.current.scrollHeight;
    counterRef.current.value = 'x';
    var singleRowHeight = counterRef.current.scrollHeight;
    var outerHeight = innerHeight;
    if (initRows) {
      outerHeight = Math.max(Number(initRows) * singleRowHeight, outerHeight);
    }
    if (maxRows) {
      outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
    }
    outerHeight = Math.max(outerHeight, singleRowHeight);
    var rowCount = Math.ceil(outerHeight / singleRowHeight);
    if (prevRows !== rowCount) {
      setRows(rowCount);
    }
  }, [textArea, autoHeight, prevRows, maxRows, initRows, counterRef]);
  useEffect(calculateRowsCount, [textArea, calculateRowsCount, value]);
  return rows;
};